import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage } from 'react-intl';

export default function LoadingErrorState() {
    return <ErrorState headline={<FormattedMessage id={'intl-msg:marketplace.error.loading'} />} />;
}
